var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-nav-item-dropdown",
    { attrs: { right: "", "no-caret": "" } },
    [
      _c("template", { slot: "button-content" }, [
        _c("img", {
          staticClass: "img-avatar",
          attrs: { src: "static/img/profile_icon.svg", alt: "admin" },
        }),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }